<h4>What this screen is for</h4>
<p>
    Checking whether the scheduled data and optimisation jobs have finished, and
    whether any of them is taking longer than it usually does. Nothing here is
    editable.
</p>

<h4>The top grid</h4>
<p>
    One row per scheduled run &mdash; <strong>Overnight</strong> and
    <strong>Intraday 1</strong> to <strong>4</strong> &mdash; and one column per
    stage of that run: the import from the reservation system, the UI refresh, the
    reporting extract, and the export back out.
</p>
<ul>
    <li><strong>Green</strong> means the stage finished, and the time shown is when it finished.</li>
    <li><strong>Red</strong> means it has been running longer than its expected runtime, and the time shown is when it <em>started</em>.</li>
    <li><strong>No colour</strong> means it is in progress and still within the expected runtime.</li>
</ul>
<p>
    The reporting extract only runs overnight, so that cell is always blank on the
    intraday rows.
</p>

<h4>RARS Errors</h4>
<p>
    The <strong>RARS Errors</strong> tab lists rows the reservation system would not
    accept. Its label carries the number of exception files on record, so
    <strong>RARS Errors</strong> with no count means nothing was reported.
</p>
<p>
    The tab shows the detail grouped by exchange: departure date, service, booking
    number, error code and the message RARS returned, with any unmapped columns behind
    the <em>detail</em> tooltip. The grid sorts and filters, and exports to Excel.
    Nothing is fetched until you open the tab.
</p>
<ul>
    <li>
        <strong>Exceptions are diagnostics, not a job status.</strong> A stage can be
        green in the grid above and still have produced exceptions.
    </li>
    <li>
        Each exchange reports its own most recent run, so the dates can differ. The
        <strong>Reported</strong> column dates every row, and a note above the grid says
        whether the latest run was clean or is itself in the list.
    </li>
    <li>
        The tab label can read <strong>unavailable</strong>. That means the exception
        files could not be read, which is not the same as a clean night - treat it as
        unknown rather than as nothing to see.
    </li>
    <li>
        Very long lists are capped, and files too large to open are skipped. The tab
        says when either has happened and which exchanges were left out, so a short list
        is never quietly mistaken for a short night.
    </li>
</ul>

<h4>The lower grid</h4>
<p>
    When the <strong>Daily</strong>, <strong>Weekly</strong> and
    <strong>Quarterly</strong> jobs last completed. The definitions underneath say
    what each of those runs covers.
</p>

<h4>Worth knowing</h4>
<ul>
    <li>
        <strong>The page does not refresh itself.</strong> Reload it to see the current
        position.
    </li>
    <li>
        <strong>A blank cell means nothing has happened inside the lookback window</strong>,
        not that the job is not scheduled. The overnight row looks back 24 hours; the
        intraday rows only look back to midnight today.
    </li>
    <li>
        "Expected runtime" is a configured average per job, not a contractual deadline.
        A red cell means slower than usual, not necessarily failed.
    </li>
    <li>
        The green and red key applies to the top grid; the lower grid is never
        colour-coded.
    </li>
</ul>
